import {
  put,
  takeEvery,
  select
} from 'redux-saga/effects';
import ktRequest from '../utils/request';
import _ from 'lodash';

export function * search (payload) {
  const q = payload.query;

  // dispatch a success action to the store with the logged in user
  yield put({
    type: 'QUERY_LOADING'
  });

  const searchResults = yield ktRequest.get('enterprise/search?q=' + encodeURIComponent(q), 'api');

  let categorizedSearchResults = [{
    title: 'Centers',
    suggestions: _.filter(searchResults.hits.hits, (hit) => hit['_index'] === 'centers')
  },
  {
    title: 'Employees',
    suggestions: _.filter(searchResults.hits.hits, (hit) => hit['_index'] === 'employees')
  },
  {
    title: 'Parents',
    suggestions: _.filter(searchResults.hits.hits, (hit) => hit['_index'] === 'parents')
  },
  {
    title: 'Children',
    suggestions: _.filter(searchResults.hits.hits, (hit) => hit['_index'] === 'children')
  }
  ];

  let store = yield select();
  let latestRequestFinished = store.searchQuery.latestRequestFinished;

  if (payload.latestRequest >= latestRequestFinished) {
    yield put({
      type: 'QUERY_SUCCESS',
      suggestions: categorizedSearchResults,
      latestRequestFinished: payload.latestRequest
    });
  }
}

export const searchQuerySagas = [
  takeEvery('QUERY_INPUT', search)
];
